import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import * as PropType from '../common/propType';
import MeScroll from '../../com/mescroll.min';
import autobind from 'autobind-decorator';
import { push, getCookie, setParamsHeaders } from '../../utils';
import store from '../../store';
import './index.less';
import { MyWifi } from '../';

export interface IScrollerFetchable {
    canFetch: boolean;
    fetch: (page, callback, err) => void;
    list?: any[];
    page: number;
    isLoadOk: any;
}

declare var window: any;
window.isLoadOk = 'ok';

export interface ScrollerPropType extends PropType.StylePropType {
    renderHeader?: () => JSX.Element | JSX.Element[];//页面头部
    renderFooter?: () => JSX.Element | JSX.Element[];//页面底部
    renderItem?: (data: any, idx: number) => JSX.Element | JSX.Element[];//直接遍历
    renderContent?: () => JSX.Element | JSX.Element[];//自由遍历
    onScrollStart?: (x, y) => void; // 滑动开始
    onScrollEnd?: (x, y, pagey) => void; // 滑动结束
    onScroll?: (y) => void; // 滑动中
    onMoving?: (y) => void;
    showLoading?: () => void;
    scrollTo?: (x, y) => void;
    bgValue?: any; // 下拉刷新背景色
    freeHeight?: any;//底部高度
    prefixCls?: string;//页面初始样式
    autoFetch?: boolean;//是否加载
    fetchable?: IScrollerFetchable;//数据
    emptyView?: () => JSX.Element;//空缺页面
    scrollToTop?: () => void;
    listStyle?: any;
    listClassName?: string;
    myY?: number;
    onHomey?: any;
    myup?: any;
    latext?: any;
    isWen?: any;
    isMore?: any;
    styles?: any;
    isUp?: boolean;
    isShopEmpty?: boolean; // 判断是否从购物车过来
    onRefresh?: any;
    isToTop?: any;
    isTabTop?: any;
    isHome?: any; // 是否从首页
    saveY?: any;
    giftTop?: number;
    className?: string; // 新增：支持额外的类名
}

@observer
class OneScroll extends React.Component<ScrollerPropType, any> {

    private mescrollm: any;
    static defaultProps = {
        prefixCls: 'mescrollone',
        autoFetch: false,
    };
    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            iswlan: true,//是否有网
            isy: true
        };
    }

    componentWillMount() {
        if (this.props.myY != 0) {
            this.setState((prevState, props) => ({
                isy: false
            }));
        }
    }

    componentDidMount() {
        let pageUrl = window.location.hash.includes("home") || window.location.hash.includes("appdetail") || window.location.hash.includes("searchResult")
        if (!pageUrl && getCookie("pub-token") === "") {
            push(`/loginPage/goHome?originPageId=home`, this);
            return
        } else {
            setParamsHeaders({
                'pub-token': getCookie("pub-token")
            });
        }
        let self = this;
        // 创建MeScroll对象,down可以不用配置,因为内部已默认开启下拉刷新,重置列表数据为第一页
        // 解析: 下拉回调默认调用mescroll.resetUpScroll(); 而resetUpScroll会将page.num=1,再执行up.callback,从而实现刷新列表数据为第一页;
        self.mescrollm = new MeScroll('mescroll', { // 请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
            up: {
                auto: !self.props.myY,
                callback: this.upCallback, // 上拉回调
                noMoreSize: 10,
                page: { size: 10, time: 300 },
                isBounce: false, // 此处禁止ios回弹,解析(务必认真阅读,特别是最后一点): http://www.mescroll.com/qa.html#q10
                // toTop: self.props.isToTop ? {
                //     warpId: null,
                //     src: require('./img/mescroll-totop.png'), // 默认滚动到1000px显示,可配置offset修改
                //     offset: 300,
                // } : null,
                toTop: {
                    warpId: null,
                    src: require('./img/mescroll-totop.png'), // 默认滚动到1000px显示,可配置offset修改
                    offset: 300,
                },
                empty: self.props.isShopEmpty || self.props.isUp ? null : { // 配置列表无任何数据的提示
                    warpId: 'dataList',
                },
                onScroll: self.onScroll.bind(this)
            },
            down: {
                onMoving: self.onMoving.bind(this),
                showLoading: self.showLoading.bind(this),
                use: !self.props.isUp,
                // 初始化下拉刷新背景色
                inited: function (mescroll, downwarp) {
                    // 初始化完毕的回调,可缓存dom
                    downwarp = downwarp.style.background = self.props.bgValue
                },
                beforeLoading: function (mescroll, downwarp) {
                    downwarp = downwarp.style.background = self.props.bgValue
                    // 准备触发下拉刷新的回调
                    return false // 如果要完全自定义下拉刷新,那么return true,此时将不再执行showLoading(),callback();
                },
            }
        });
        if (this.props.myY) {
            this.mescrollm.setScrollTop(this.props.myY);
        }
        // this.upCallback({ size: 10, time: 300 })
        // this.getListDataFromNet()

        if (this.props.isTabTop) {
            this.mescrollm.scrollTo(0, 0);
        }
    }
    upCallback = (page: any, mescroll: any = '') => {
        let self = this;
        // 联网加载数据
        this.getListDataFromNet(page.num, page.size, function (curPageData, hasNext) {
            // curPageData=[]; // 打开本行注释,可演示列表无任何数据empty的配置
            // 方法四 (不推荐),会存在一个小问题:比如列表共有20条数据,每页加载10条,共2页.如果只根据当前页的数据个数判断,则需翻到第三页才会知道无更多数据,如果传了hasNext,则翻到第二页即可显示无更多数据.
            // self.mescrollm.endSuccess(curPageData.length);
            // 方法三(推荐): 您有其他方式知道是否有下一页 hasNext
            if (hasNext == null) {
                hasNext = false;
                self.mescrollm.endSuccess(0, false);
                self.mescrollm.endUpScroll(true);
                let divmescroll: any = document.getElementsByClassName('mescroll-empty')[0];
                if (divmescroll && divmescroll != undefined) {
                    divmescroll.style.display = 'none';
                }
            } else {
                hasNext = hasNext ? true : false;
                if (hasNext) {
                    self.mescrollm.endSuccess(page.size, hasNext);
                } else {
                    self.mescrollm.endSuccess(curPageData.length, hasNext);
                } // 必传参数(当前页的数据个数, 是否有下一页true/false)
                self.props.isShopEmpty && self.props.onRefresh();
            }
            if (self.props.isShopEmpty && curPageData.length === 0) {
                let divmescroll: any = document.getElementsByClassName('mescroll-upwarp')[0];
                divmescroll.style.display = 'none';
                self.mescrollm.hideUpScroll();
            }
            let nodata: any = document.getElementsByClassName('upwarp-nodata')[0];
            let fetchable: any = self.props.fetchable;
            if (window.location.href.indexOf('searchResult') != -1 && nodata && fetchable) {
                if (fetchable.lists.length < 6) {
                    nodata.style.display = 'none';
                } else {
                    nodata.style.display = 'block';
                }
            }
        }, function () {
            // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
            self.mescrollm.endErr();
        });
    }
    getListDataFromNet = (pageNum, pageSize, successCallback, errorCallback) => {
        let self = this;
        let fetchable: any = self.props.fetchable;
        if (fetchable) {
            let mynum = self.state.isy ? pageNum : 0;
            fetchable.fetch(mynum, function (data, hasNext) {
                self.setState({
                    isy: true,
                    iswlan: true
                });
                if (self.props.isShopEmpty && data.length !== 0) {
                    store.user.shopNum();
                }
                let divmescroll: any = document.getElementsByClassName('mescroll-upwarp')[0];
                if (divmescroll != undefined) {
                    divmescroll.style.display = 'none';
                }
                successCallback(data, hasNext);
            }, function (err) {
                if (err) {
                    self.setState({ iswlan: false });
                    errorCallback(err);
                }
            });
        } else {
            let divmescroll: any = document.getElementsByClassName('mescroll-upwarp')[0];
            if (divmescroll != undefined) {
                divmescroll.style.display = 'none';
            }
            self.mescrollm.hideUpScroll();
        }
    }
    @autobind
    resetUpScroll() {
        this.mescrollm.resetUpScroll(false);
    }

    onScroll(mescroll, y) {
        if (this.props.onScroll) {
            this.props.onScroll(y);
        }
    }

    onMoving(mescroll, rate, downHight) {
        if (this.props.onMoving) {
            this.props.onMoving(downHight);
        }
    }

    showLoading() {
        if (this.props.showLoading) {
            this.props.showLoading();
        }
    }

    @autobind
    destroy() {
        this.mescrollm.destroy();
    }

    @autobind
    scrollToTop() {
        this.mescrollm.scrollTo(0, 0);
    }

    componentWillUnmount() {
        let pageUrl = window.location.hash.includes("home") || window.location.hash.includes("appdetail") || window.location.hash.includes("searchResult")
        if (!pageUrl && getCookie("pub-token") === "") {
            // push(`/loginPage/goHome?originPageId=home`, this);
        } else {
            if (this.props.onHomey) {
                this.props.onHomey(this.mescrollm.getScrollTop());
            }
            this.mescrollm.destroy();
        }
    }

    @autobind
    apprefresh() {
        this.mescrollm.resetUpScroll();
    }

    @autobind
    liLoad() {
        if (this.props.myY) {
            this.mescrollm.scrollTo(this.props.myY, 10);
        }
    }

    @autobind
    toGiftTop() {
        if (this.props.giftTop) {
            this.mescrollm.scrollTo(this.props.giftTop, 100);
        }
    }

    render() {
        let { renderHeader, renderItem, renderContent, fetchable, freeHeight, styles, className } = this.props;
        let list: any[] = [];
        if (fetchable && fetchable.list) {
            list = fetchable.list;
        }
        let style = PropType.getStyle(this.props);
        let h = freeHeight || 0;
        if (!style.height) {
            style.bottom = h;
        }
        if (typeof styles === 'object') {
            style.top = styles.top;
            style.background = styles.background;
        }
        
        // 渲染商品列表
        const renderItems = list && list.map((item, index) => {
            return renderItem && renderItem(item, index);
        });
        
        return (
            <div className={this.props.prefixCls}>
                {renderHeader && renderHeader()}
                <div
                    id="mescroll"
                    className="mescroll"
                    style={style}
                >
                    {this.state.iswlan ?
                        <div id="dataList" className="data-list clearfix">
                            {renderContent && renderContent()}
                            {/* 商品列表容器，应用瀑布流或列表样式 */}
                            <div className={className || 'list-container'}>
                                {renderItems}
                            </div>
                        </div>
                        :
                        <MyWifi />
                    }
                </div>
            </div>
        );
    }
}

export default OneScroll;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/onescroll/index.tsx